// Pure derivations from live child data. Nothing here reads mocks.

export function deriveStudentSummary(assignments, courses) {
  const list = Array.isArray(assignments) ? assignments : [];
  const total = list.length;
  const completed = list.filter(a => a.status === 'completed').length;
  const overdue = list.filter(a => a.status === 'overdue').length;
  const completionRate = total > 0 ? Math.round((completed / total) * 100) : 0;
  const courseList = Array.isArray(courses) ? courses : [];
  return { total, completed, overdue, completionRate, courseCount: courseList.length };
}

export function deriveOverallStatus(summary) {
  if (!summary || summary.total === 0) return 'no-data';
  if (summary.overdue >= 2) return 'at-risk';
  if (summary.overdue >= 1 || summary.completionRate < 60) return 'needs-attention';
  return 'on-track';
}

export function deriveSummaryText(student, summary) {
  const name = student?.firstName || 'Your student';
  if (!summary || summary.total === 0) {
    return `${name} does not have activity to summarize yet.`;
  }
  if (summary.overdue > 0) {
    return `${name} has ${summary.overdue} overdue assignment${summary.overdue === 1 ? '' : 's'} and ${summary.completionRate}% of assignments completed this period.`;
  }
  return `${name} has ${summary.completionRate}% of assignments completed and no overdue work.`;
}
